import Loading from 'components/Loading';
import UserContext from 'contexts/user';
import { PropsWithChildren, useContext } from 'react';
import { Route } from 'react-router';
import PrivateRoute from '../PrivateRoute';
type LoginRouteProps = {
  component: (props: any) => JSX.Element;
};
const LoginRoute = ({
  component,
  ...rest
}: PropsWithChildren<Route['props'] & LoginRouteProps>) => {
  const { user, fetching } = useContext(UserContext);
  if (fetching) {
    return <Loading text="Loading" />;
  }
  let loggedin = !!user;
  return (
    <PrivateRoute
      checks={[loggedin]}
      component={component}
      errorMessage={'You need to login first'}
      redirectTo="/login"
      {...rest}
    />
  );
};

export default LoginRoute;
